import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';

const AboutPage = () => {
  const { t } = useLocalization();
  return (
    <div style={{ padding: '4rem 2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#343a40', fontWeight: '700' }}>{t('about.title')}</h1>
      <hr style={{ border: 'none', borderTop: '2px solid #dee2e6', marginBottom: '2rem', width: '100px', marginLeft: '0' }} />
      
      <p style={{ marginBottom: '1.5rem', color: '#6c757d', fontSize: '1.1rem' }}>
        {t('about.description')}
      </p>
      
      <h3 style={{ fontSize: '1.3rem', marginBottom: '1rem', marginTop: '2rem', color: '#495057', fontWeight: '600' }}>{t('about.whatWeProvide')}</h3>
      
      <ul style={{ marginBottom: '1.5rem', color: '#6c757d', fontSize: '1.1rem', paddingLeft: '1.5rem' }}>
        <li style={{ marginBottom: '0.8rem' }}>
          <strong>{t('about.service1Title')}</strong> {t('about.service1Description')}
        </li>
        <li style={{ marginBottom: '0.8rem' }}>
          <strong>{t('about.service2Title')}</strong> {t('about.service2Description')}
        </li>
        <li style={{ marginBottom: '0.8rem' }}>
          <strong>{t('about.service3Title')}</strong> {t('about.service3Description')}
        </li>
        <li style={{ marginBottom: '0.8rem' }}>
          <strong>{t('about.service4Title')}</strong> {t('about.service4Description')}
        </li>
      </ul>
      
      <p style={{ marginBottom: '1.5rem', color: '#6c757d', fontSize: '1.1rem', fontWeight: '500' }}>
        {t('about.conclusion')}
      </p>
      
      <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem', marginTop: '3rem', color: '#343a40', fontWeight: '700' }}>{t('about.taskExamplesTitle')}</h1>
      <hr style={{ border: 'none', borderTop: '2px solid #dee2e6', marginBottom: '2rem', width: '100px', marginLeft: '0' }} />
      
      <div style={{ display: 'grid', gap: '4rem', marginBottom: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img 
            src="/app/assets/img/example-task-1.png" 
            alt="Task example 1" 
            style={{ height: '200px', width: 'auto', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6c757d', fontSize: '1rem', maxWidth: '600px' }}>
            {t('about.taskExample1')}
          </p>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img 
            src="/app/assets/img/example-task-2.png" 
            alt="Task example 2" 
            style={{ height: '200px', width: 'auto', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6c757d', fontSize: '1rem', maxWidth: '600px' }}>
            {t('about.taskExample2')}
          </p>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img 
            src="/app/assets/img/example-task-3.png" 
            alt="Task example 3" 
            style={{ height: '200px', width: 'auto', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6c757d', fontSize: '1rem', maxWidth: '600px' }}>
            {t('about.taskExample3')}
          </p>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img 
            src="/app/assets/img/example-task-4.png" 
            alt="Task example 4" 
            style={{ height: '200px', width: 'auto', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6c757d', fontSize: '1rem', maxWidth: '600px' }}>
            {t('about.taskExample4')}
          </p>
        </div>
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <img 
            src="/app/assets/img/example-task-5.png" 
            alt="Task example 5" 
            style={{ height: '200px', width: 'auto', borderRadius: '8px', border: '1px solid #dee2e6', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6c757d', fontSize: '1rem', maxWidth: '600px' }}>
            {t('about.taskExample5')}
          </p>
        </div>
      </div>
      
      <p style={{ marginBottom: '1.5rem', color: '#6c757d', fontSize: '1rem', fontStyle: 'italic' }}>
        {t('about.manyMoreTasks')}
      </p>
    </div>
  );
};

export default AboutPage;